import { render, staticRenderFns } from "./Casebook.vue?vue&type=template&id=7df6b881&scoped=true&"
import script from "./Casebook.vue?vue&type=script&lang=ts&"
export * from "./Casebook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6b881",
  null
  
)

export default component.exports